<template>
    <lottie-player
        v-if="animationData"
        :src.prop="animationData"
        background="transparent"
        speed="1"
        loop
        autoplay
        :class="sizeClass"
    ></lottie-player>
    <span
        v-else
        role="status"
        aria-label="Loading"
        data-testid="muval-loader-fallback"
        :class="sizeClass"
        class="inline-block"
    >
        <span
            v-if="failed"
            class="block h-full w-full animate-spin rounded-full border-2 border-muval-gray-3 border-t-muval-blue-2"
        ></span>
    </span>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue';
import { useLottieAnimation } from '@composables/useLottieAnimation';

const sizes = {
    xs: 'w-8 h-8',
    s: 'w-12 h-12',
    m: 'w-16 h-16',
    l: 'w-24 h-24',
    xl: 'w-28 h-28',
    '2xl': 'w-32 h-32',
    '3xl': 'w-48 h-48',
    '4xl': 'w-52 h-52',
} as const;

type Size = keyof typeof sizes;

const props = defineProps({
    loader: {
        type: String,
        required: false,
        default: '/moveprologo.json',
    },
    size: {
        type: String as PropType<Size>,
        required: false,
        default: 'xl',
    },
});

const sizeClass = computed(() => sizes[props.size] ?? sizes.xl);

const { animationData, failed } = useLottieAnimation(() => props.loader);
</script>
